import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMatcapIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9,
			fill: "currentColor",
			opacity: .15
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 3,
			fill: "currentColor",
			stroke: "none",
			opacity: .3
		})
	]
});
export default SvgMatcapIcon;
